'use client';
/** @jsxImportSource @emotion/react */

import { type FC } from 'react';

import type { SlideProps as MuiSlideProps } from '@mui/material/Slide';

import MuiSlide from '@mui/material/Slide';

/**
 * The Slide component uses transitions and animations that depend on specific DOM properties (e.g., height, padding)
 * typically available on block-level elements like `div`. Using `span`, which is an inline element, can break this behavior.
 * And the default implementation in MUI is also broken, and altering it could lead to issues.
 *
 * https://serko.atlassian.net/browse/ZDS-1034
 */
type ExcludedMuiProps = 'component';

export type SlideProps = Omit<MuiSlideProps, ExcludedMuiProps>;

export const Slide: FC<SlideProps> = MuiSlide;

Slide.displayName = 'Slide';
